import { Skeleton } from 'Skeleton';

const BOX_HEIGHTS = ['h-[180px]', 'h-[140px]', 'h-[160px]'];

export function DesktopSidebarSkeleton() {
    return (
        <div data-testid="desktop-sidebar-skeleton">
            {BOX_HEIGHTS.map(height => (
                <Skeleton
                    key={height}
                    className={`${height} mb-7.5 rounded-[5px] bg-slate-grey-100 before:via-slate-grey-200`}
                />
            ))}
        </div>
    );
}
